export const formartListAsSentence = (list) => {
  if (!Array.isArray(list)) return ''
  return list
    .map((item) => `${item}`)
    .join(', ')
    .replace(/, ([^,]*)$/, ' and $1')
}
